// ==========================================================================
// components/Page.tsx — page title + optional action, and a Section heading.
// FF-026: titles are large Cinzel, set in sentence case by the font's own
// small-caps look; subtitles are calm and short.
// ==========================================================================
import type { ReactNode } from "react";

export function PageHeader({ title, subtitle, action }: { title: ReactNode; subtitle?: ReactNode; action?: ReactNode }) {
  return (
    <div className="mb-7 flex flex-wrap items-end justify-between gap-4 lg:mb-9">
      <div className="min-w-0 flex-1">
        <h1 className="font-heading text-3xl font-semibold leading-tight text-ink lg:text-[40px]">{title}</h1>
        {subtitle && <p className="mt-1.5 max-w-2xl text-[15px] text-ink-muted">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function Section({ title, action, children, className = "" }: { title: string; action?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={className}>
      <div className="mb-3 flex items-baseline justify-between">
        <h2 className="text-[17px] font-semibold text-ink">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
